'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _useHovered = require('../hooks/useHovered');

var _useHovered2 = _interopRequireDefault(_useHovered);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HoverProvider = function HoverProvider(props) {
  return props.children((0, _useHovered2.default)(props));
};

HoverProvider.displayName = 'HoverProvider';

exports.default = HoverProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/providers/HoverProvider.js
// module id = 80
// module chunks = 177